import { render } from "./EditDepartment.vue?vue&type=template&id=75357ff0"
import script from "./EditDepartment.vue?vue&type=script&lang=js"
export * from "./EditDepartment.vue?vue&type=script&lang=js"

import "./EditDepartment.vue?vue&type=style&index=0&id=75357ff0&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\lotus-Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__